import { pushGaPageView } from '@common/Tracking/GaTracking/GaPageView';

const pushToDataLayer = (data) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
};

const composeGaEvent = ({ category = 'favourites', action = null, label = null }) => ({
    event: 'ga_event',
    event_info: {
        category,
        action,
        label,
        value: null,
        non_interaction: 1
    }
});

export const openFavoritesTracking = () => {
    pushGaPageView({
        pagePath: '/eu/en/customer/my-lists/favourites',
        pageType: 'Customer',
        pageTitle: 'Favorites'
    });
};

export const openRecentsTracking = () => {
    pushGaPageView({
        pagePath: '/eu/en/customer/my-lists/recent',
        pageType: 'Customer',
        pageTitle: 'Recently viewed'
    });
};

export const openCollectionsTracking = () => {
    pushGaPageView({
        pagePath: '/eu/en/customer/my-lists/collections',
        pageType: 'Customer',
        pageTitle: 'Wishlists'
    });
};

export const openCollectionItemsTracking = () => {
    pushGaPageView({
        pagePath: '/eu/en/customer/my-lists/product-collection',
        pageType: 'Customer',
        pageTitle: 'Product-Wishlist'
    });
};

export const onFavoriteAddTracking = () => {
    pushToDataLayer({
        event: 'ga_event',
        event_info: {
            type: 'ua',
            category: 'favourites',
            action: 'add to favourites',
            label: 'recently viewed',
            value: null,
            non_interaction: 1
        }
    });
};

export const onFavoriteRemoveTracking = () => {
    pushToDataLayer({
        event: 'ga_event',
        event_info: {
            type: 'ua',
            category: 'favourites',
            action: 'remove from favourites',
            label: 'favourites',
            value: null,
            non_interaction: 1
        }
    });
};

export const onEditListTracking = () => {
    pushToDataLayer(composeGaEvent({ category: 'favourites', action: 'edit list' }));
};

export const onEditListCancelTracking = () => {
    pushToDataLayer(composeGaEvent({ category: 'favourites', action: 'cancel' }));
};

export const onDeleteSelectedTracking = (amount, total) => {
    pushToDataLayer(composeGaEvent({
        category: 'favourites',
        action: 'delete selected',
        label: (amount === total) ? 'all products' : amount
    }));
};

export const onEmptyStateTracking = () => {
    pushToDataLayer(composeGaEvent({ category: 'favourites', action: 'empty state' }));
};

export const onContinueShoppingTracking = () => {
    pushToDataLayer(composeGaEvent({ category: 'favourites', action: 'continue shopping' }));
};

export const onFilterToggleTracking = (filterName) => {
    pushToDataLayer(composeGaEvent({ category: 'filters', action: filterName }));
};

export const onClearFilterTracking = () => {
    pushToDataLayer(composeGaEvent({ category: 'filters', action: 'clear filter', label: 'clear all' }));
};

export const onSortTracking = (sortId) => {
    pushToDataLayer(composeGaEvent({ category: 'category', action: 'sorting', label: sortId }));
};
